import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Redesigned newsletter block — clean, editorial. OBEY-reference proportions.
export default function EmailSignup({ source = "newsletter_footer" }) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/subscribe`, { email, source });
      if (res.data.already_subscribed) {
        toast("You're already on the list.");
      } else {
        if (res.data.discount_token) localStorage.setItem("fta_discount_v1", res.data.discount_token);
        toast.success("You're on the list.", { description: res.data.discount_token ? "10% off unlocked for your next order." : "Watch your inbox." });
      }
      setEmail(""); setDone(true);
    } catch (err) {
      if (err?.response?.status === 422) toast.error("That email address doesn't look right.");
      else toast.error("Couldn't reach the list right now. Try again in a moment.");
    } finally { setSubmitting(false); }
  };

  return (
    <section id="updates" data-testid="updates-section" className="relative bg-white text-black py-20 md:py-28 border-t border-black/10">
      <div className="px-4 md:px-10 max-w-3xl mx-auto text-center">
        <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B48A00] mb-3">Philadelphia Freeway · FTA</div>
        <h2 className="font-wide uppercase text-4xl md:text-5xl leading-[0.95]">Join Our Newsletter</h2>
        <p className="mt-4 font-body text-black/70 text-base md:text-lg">Stay updated with the latest news, releases and updates.</p>
        <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto" data-testid="signup-form">
          <input data-testid="signup-email" type="email" required placeholder="Your email"
            value={email} onChange={(e) => { setEmail(e.target.value); setDone(false); }}
            className="flex-1 bg-transparent border border-black/25 focus:border-black outline-none px-4 py-3 font-body text-black placeholder-black/40" />
          <button data-testid="signup-submit" type="submit" disabled={submitting || done}
            className="bg-black text-white font-display uppercase tracking-[0.22em] text-sm px-8 py-3 hover:bg-[#F4C10A] hover:text-black transition-colors disabled:opacity-60">
            {done ? "You're On The List" : submitting ? "Sending…" : "Subscribe"}
          </button>
        </form>
        <p data-testid="signup-consent" className="mt-4 font-mono text-[10px] tracking-[0.2em] uppercase text-black/50">
          By subscribing you agree to our <Link data-testid="signup-privacy-link" to="/privacy" className="underline hover:text-black">Privacy Policy</Link>.
        </p>
      </div>
    </section>
  );
}
